"use client";
import { useState, useEffect } from "react";
import {
  DEFAULT_LANGUAGE,
  LanguageContext,
  LANGUAGE_COOKIE_NAME,
  isSupportedLanguage,
} from "./language-context";
import type { LanguageProviderProps, Language } from "@/types/interfaces/language";

function setCookie(name: string, value: string, days: number = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  if (process.env.NODE_ENV === "production") {
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Strict; Secure`;
  } else {
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Strict`;
  }
}

export function LanguageProvider({ children, initialLanguage }: LanguageProviderProps) {
  const [language, setLanguageState] = useState<Language>(
    isSupportedLanguage(initialLanguage) ? initialLanguage : DEFAULT_LANGUAGE,
  );

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    setCookie(LANGUAGE_COOKIE_NAME, lang);
    document.documentElement.lang = lang;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
